import React, { useState } from 'react';

import { Column } from '../../../utils/models';
import { InspectedCacheItem } from '../../../hooks/useGeneralReportOverviewItems';
import { renderCell } from '../../../utils/utilities';

import Conditional from '../../common/conditional';
import InspectedItem from '../../blocks/inspected-item';

import css from './style.module.scss';

interface TableProps {
    columns: Column[];
    item: InspectedCacheItem;
}

const GeneralReportOverviewTableRow: React.FC<TableProps> = ({ columns, item }) => {
    const [isExpanded, setExpanded] = useState(false);

    return ( 
            <React.Fragment key={item.projectDetails._id}>
                <tr>
                    {columns.map((column: Column) => (
                        <td key={item.projectDetails._id + column.path}>
                            {renderCell(item.projectDetails, column)}
                        </td>
                    ))}
                    <td>
                        <button onClick={() => setExpanded((prev) => !prev)} className={css['general-report-overview-chevron']}>
                            <i className={`bi bi-chevron-${isExpanded ? 'up' : 'down'}`}></i>
                        </button>
                    </td>
                </tr>
               <Conditional isVisible={isExpanded}>
                    <tr>
                        <td className={css['general-report-overview-inspected-item']} colSpan={columns.length + 1}>
                            <h3>Inspected Items</h3>
                            <InspectedItem data={item.inspectedItems} />
                        </td>
                    </tr>
               </Conditional>
            </React.Fragment>
     );
}

export default GeneralReportOverviewTableRow;